// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"074ee3d5","464":"1b6d091b"}[chunkId] + ".chunk.css";
};